// Progress: math mastery, speech progress, usage, insights, reports,
// certificates and teacher/therapist sharing.
import { MathProgress } from "../MathProgress";
import { MasteryInsights } from "../MasteryInsights";
import { UsageTrends } from "../UsageTrends";
import { MathDigest } from "../MathDigest";
import { TeacherShare } from "../TeacherShare";
import { MonthlyPoster } from "../MonthlyPoster";
import { RecapPreview } from "../../RecapPreview";
import { FamilyLibrary } from "../../library/FamilyLibrary";
import { HomeworkSummaryCard } from "../HomeworkSummaryCard";
import { ExamPrepSummaryCard } from "../ExamPrepSummaryCard";
import { CodeLabSummaryCard } from "../CodeLabSummaryCard";
import { LifeSkillsReportCard } from "../LifeSkillsReportCard";
import { MovieInsightsCard } from "../MovieInsightsCard";
import { ReadingReportCard } from "../ReadingReportCard";
import { SpeechProgressCard } from "../SpeechProgressCard";
import { LearnLoopMastery } from "../LearnLoopMastery";

export const ProgressSection = () => (
  <div className="space-y-8" data-testid="dash-section-progress">
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold font-display">Progress</h1>
      <p className="text-muted-foreground mt-1">
        Mastery, usage, skills needing support, reports and sharing.
      </p>
    </div>
    <div className="space-y-4">
      <MathProgress />
      <SpeechProgressCard />
      <HomeworkSummaryCard />
      <ExamPrepSummaryCard />
      <CodeLabSummaryCard />
      <MovieInsightsCard />
      <ReadingReportCard />
      <LifeSkillsReportCard />
      <LearnLoopMastery />
      <MasteryInsights />
      <UsageTrends />
      <MathDigest />
      <MonthlyPoster />
      <TeacherShare />
      <RecapPreview />
    </div>
    <FamilyLibrary />
  </div>
);
